module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "div_autre",
    attrs: {
      "epub:type": "preamble"
    }
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-003"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_XV",
      "role": "doc-pagebreak",
      "title": "XV"
    }
  }, [_c('h1', {
    staticClass: "pre_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("Abbreviations")])]), _vm._v(" "), _c('div', {
    staticClass: "dev"
  }, [_c('div', {
    staticClass: "tableau",
    attrs: {
      "id": "tableau-001"
    }
  }, [_c('div', {
    staticClass: "table-align"
  }, [_c('table', {
    staticStyle: {
      "border-collapse": "collapse",
      "border-spacing": "0px"
    }
  }, [_c('colgroup', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('col', {
    staticStyle: {
      "padding": "1px"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "83.25%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("AAP")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("American Academy of Pediatrics")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("APA")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("American Psychological Association")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("ASD")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("autism spectrum disorder")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("DBT")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("dialectical behavior therapy")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("DSM")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("American Psychiatric Association, "), _c('i', [_vm._v("Diagnostic and Statistical Manual of Mental Disorders")])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("GCS")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("gender-confirmation surgery")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("GICE")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("gender-identity-change efforts")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("GRIT")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Gender and Religious Identity Therapy")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("HT")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("hormone therapy")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("LGBTQ+")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("lesbian, gay, bisexual, transgender, queer, and other")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("SAMHSA")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Substance Abuse and Mental Health Services Administration")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("SOCE")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("sexual-orientation-change efforts")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("WPATH")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("World Professional Association for Transgender Health")])])])])])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30ed1363","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre4.vue
// module id = 69
// module chunks = 0